import React, { useState } from "react";
import { useT } from "../i18n/LanguageContext";
import { Globe2, Check } from "lucide-react";

/**
 * Sélecteur de langue compact — drapeaux + nom natif.
 * À placer dans la navbar / header de la Landing.
 */
export default function LanguageSelector({ compact = false, variant = "dark" }) {
  const { lang, setLang, langs, t } = useT();
  const [open, setOpen] = useState(false);
  const current = langs.find((l) => l.code === lang) || langs[0];

  const btnClass = variant === "light"
    ? "bg-slate-100 hover:bg-slate-200 border-slate-300 text-slate-900"
    : "bg-white/10 hover:bg-white/20 border-amber-300/30 text-white";

  return (
    <div className="relative" data-testid="language-selector-wrapper">
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 ${btnClass} border rounded-sm px-3 py-2 transition`}
        data-testid="language-selector-button"
        aria-label={t("lang_selector_label")}
      >
        <Globe2 className="h-4 w-4" />
        <span className="text-base leading-none">{current.flag}</span>
        {!compact && <span className="text-xs font-medium hidden sm:inline">{current.native}</span>}
      </button>

      {open && (
        <>
          {/* Backdrop to close on outside click */}
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            className="absolute right-0 mt-2 w-56 bg-white border-2 border-amber-600 rounded-sm shadow-2xl z-50 max-h-[70vh] overflow-y-auto max-sm:fixed max-sm:top-16 max-sm:right-2 max-sm:left-2 max-sm:w-auto max-sm:mt-0 max-sm:max-h-[80vh]"
            data-testid="language-selector-menu"
          >
            <div className="p-2 bg-amber-50 border-b border-amber-200">
              <p className="text-[10px] uppercase tracking-[0.15em] text-amber-900 font-medium">
                🌍 {t("lang_selector_label")}
              </p>
            </div>
            <ul>
              {langs.map((l) => (
                <li key={l.code}>
                  <button
                    onClick={() => { setLang(l.code); setOpen(false); }}
                    className={`w-full text-left px-3 py-2.5 flex items-center gap-3 transition ${
                      lang === l.code ? "bg-amber-100 text-amber-900 font-medium" : "text-slate-700 hover:bg-slate-50"
                    }`}
                    data-testid={`lang-option-${l.code}`}
                  >
                    <span className="text-xl">{l.flag}</span>
                    <span className="text-sm flex-1" dir={l.rtl ? "rtl" : "ltr"}>{l.native}</span>
                    {lang === l.code && <Check className="h-4 w-4 text-amber-700" />}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
